import React from 'react';
import { WrappedFieldProps } from 'redux-form';
import { FormControlProps, InputLabelProps, MenuItem } from '@material-ui/core';

import FormSelect from 'retired/FormSelect';
import { currencies } from 'utils/currencyFormat';

type Props = {
  fullWidth: boolean;
  required: boolean;
  label: string;
  helperText: string;
  defaultValue: string;
  formControlProps: FormControlProps;
  labelProps: InputLabelProps;
} & WrappedFieldProps;

const FormCurrencySelect = (props: Props): JSX.Element => (
  <FormSelect {...props}>
    {Object.values(currencies)
      .map((c) => ({ name: c.label, value: c.code }))
      .map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.name}
        </MenuItem>
      ))}
  </FormSelect>
);

export default FormCurrencySelect;
